import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { ConfigurationService } from '../../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class ProvisionsForLiabilitiesService {
  //URL: any = 'https://localhost:44306/api/ProvisionsForLiabilities/';

  URL = this.ConfigService.getAPIBaseUrl() + 'api/ProvisionsForLiabilities/';

  constructor(public HttpClient: HttpClient, private ConfigService: ConfigurationService) { }


  SaveProvisionsForLiabilities(directors_Remunerations) {
    debugger;
    return this.HttpClient.post(this.URL + 'InsertProvisionsForLiabilities', directors_Remunerations)
  }

  GetOneProvisionsForLiabilities(APPeriodId) {
    debugger;
    return this.HttpClient.get(this.URL + "GetOneProvisionsForLiabilities?APPeriodId=" + APPeriodId)
  }

  GetOneProvisionsForLiabilities_LY(APPeriodId) {
    debugger;
    return this.HttpClient.get(this.URL + "GetOneProvisionsForLiabilities_LY?APPeriodId=" + APPeriodId)
  }
}
